import { useFocusEffect } from "expo-router";
import { PropsWithChildren } from "react";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";
import { Pressable } from "react-native-gesture-handler";
import Animated from "react-native-reanimated";
type ModalProps = PropsWithChildren & {
  style?: StyleProp<ViewStyle>;
  onUnmount?: () => void;
};
export default function Modal({ children, onUnmount, style }: ModalProps) {
  useFocusEffect(() => {
    return () => {
      onUnmount?.();
    };
  });

  return (
    <Pressable style={[style, styles.container, StyleSheet.absoluteFill]}>
      <Animated.View style={styles.view}>{children}</Animated.View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.4)",
    cursor: "pointer",
  },
  view: {},
});
